// import components
import { styled, Box, ListItem } from '@mui/material';
import { StyledTypographyTruncate } from './Typography/Typography.styles';

export const StyledListItem = styled(ListItem)(() => ({
  display: 'flex',
  width: '100%'
}));

export const StyledListItemBox = styled(Box)(() => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center'
}));

export const StyledListItemTimeBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(4)
}));

export const StyledLabelTruncateTypography = styled(StyledTypographyTruncate)(
  ({ theme }) => ({
    width: theme.spacing(16),
    paddingRight: theme.spacing(4)
  })
);
